import { useTheme } from '@chakra-ui/react';
import styled from '@emotion/styled';
import { PatternFormat } from 'react-number-format';

import InputGroup from '~/common/components/Inputs/InputGroup';

const StyledPatternFormat = styled<any>(PatternFormat)`
  padding-left: 1rem;
  width: 100%;
  border-radius: 6px;

  ${(props) =>
    props.disabled &&
    `
      opacity: 0.5;
      cursor: not-allowed;
    `}
  ${(props) =>
    props['data-is-error'] &&
    `
        background-color: unset;
        border-color: ${props.theme.colors.red[500]};
      `}
`;

type PatternFormatInputProps = {
  onChange?: (...args: any[]) => any;
  disabled?: boolean;
  pattern?: string;
  isError?: boolean;
  mask?: string;
  allowEmptyFormatting?: boolean;
  tabIndex?: number;
  name?: string;
  id?: string;
  value?: string | number;
  placeholder?: string;
  'data-testid'?: string;
  isInvalid?: boolean;
  'aria-label'?: string;
};

export default function PatternFormatInput({
  onChange,
  disabled,
  pattern,
  mask,
  allowEmptyFormatting,
  tabIndex = 0,
  isError,
  isInvalid = false,
  ...props
}: Readonly<PatternFormatInputProps>) {
  const { colors } = useTheme();
  return (
    <InputGroup
      height="2.5rem"
      border={isInvalid ? '2px solid' : '1px solid'}
      borderColor={isInvalid ? colors?.red[500] : colors?.gray[200]}
      display="flex"
      flexDirection="row"
      backgroundColor={colors?.white}
      overflow={isInvalid ? 'hidden' : 'visible'}
    >
      <StyledPatternFormat
        {...props}
        allowEmptyFormatting={allowEmptyFormatting}
        tabIndex={tabIndex}
        disabled={disabled}
        format={pattern}
        mask={mask}
        onChange={onChange}
        data-is-error={isError}
      />
    </InputGroup>
  );
}
